import * as firebase from "firebase/app";
import "firebase/firestore";

// Setting up the firestore app
const store = firebase.firestore();

/**
 * Increments the value of total number of active requests by one in the database.
 * @param None
 */
export async function incrementActiveRequestCount() {
  store
    .collection("stats")
    .doc("requests")
    .update({ activeCount: firebase.firestore.FieldValue.increment(1) });
}

/**
 * Decrements the value of total number of active requests by one in the database.
 * @param None
 */
export async function decrementActiveRequestCount() {
  store
    .collection("stats")
    .doc("requests")
    .update({ activeCount: firebase.firestore.FieldValue.increment(-1) });
}

/**
 * Fetches and returns total number of a active requests from the database.
 * @param None
 */
export async function getActiveRequestsCount(): Promise<any> {
  return new Promise((resolve, reject) => {
    store
      .collection("stats")
      .doc("requests")
      .get()
      .then((snapshot: any) => {
        if (snapshot.exists) resolve(snapshot.data().activeCount);
        else reject(null);
      })
      .catch((err) => reject(err));
  });
}

/**
 * Increments the value of donors by one in the database.
 * @param None
 */
export async function incrementDonorCount() {
  store
    .collection("stats")
    .doc("users")
    .update({ donors: firebase.firestore.FieldValue.increment(1) });
}

/**
 * Decrements the value of donors by one in the database.
 * @param None
 */
export async function decrementDonorCount() {
  store
    .collection("stats")
    .doc("users")
    .update({ donors: firebase.firestore.FieldValue.increment(-1) });
}

/**
 * Fetches and returns total number of a donors from the database.
 * @param None
 */
export async function getDonorsCount(): Promise<any> {
  return new Promise((resolve, reject) => {
    store
      .collection("stats")
      .doc("users")
      .get()
      .then((snapshot: any) => {
        if (snapshot.exists) resolve(snapshot.data().donors);
        else reject(null);
      })
      .catch((err) => reject(err));
  });
}

/**
 * Increments the value of requesters by one in the database.
 * @param None
 */
export async function incrementRequesterCount() {
  store
    .collection("stats")
    .doc("users")
    .update({ requesters: firebase.firestore.FieldValue.increment(1) });
}

/**
 * Decrements the value of requesters by one in the database.
 * @param None
 */
export async function decrementRequesterCount() {
  store
    .collection("stats")
    .doc("users")
    .update({ requesters: firebase.firestore.FieldValue.increment(-1) });
}

/**
 * Fetches and returns total number of a requesters from the database.
 * @param None
 */
export async function getRequestersCount(): Promise<any> {
  return new Promise((resolve, reject) => {
    store
      .collection("stats")
      .doc("users")
      .get()
      .then((snapshot: any) => {
        if (snapshot.exists) resolve(snapshot.data().requesters);
        else reject(null);
      })
      .catch((err) => reject(err));
  });
}

/**
 * Increments the value of total number of requests by one in the database.
 * @param None
 */
export async function incrementTotalRequestCount() {
  store
    .collection("stats")
    .doc("requests")
    .update({ totalCount: firebase.firestore.FieldValue.increment(1) });
}
